<template>
  <div class="color-fabric" ref="colorFabric">
    <div class="toolbar">
      <button class="btn-apply" v-if="applyButton" @click="applyChanges">
        <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2.20711 5.2929C1.81658 4.90238 1.18342 4.90238 0.792893 5.2929C0.402369 5.68343 0.402369 6.31659 0.792893 6.70712L5.79289 11.7071C6.19802 12.1122 6.86002 12.0948 7.24329 11.669L16.2433 1.66897C16.6128 1.25846 16.5795 0.626173 16.169 0.256714C15.7585 -0.112745 15.1262 -0.0794662 14.7567 0.331044L6.46181 9.5476L2.20711 5.2929Z"
                fill="white"/>
        </svg>
        Zastosuj kolor
      </button>
      <div class="swatches"
           :class="{ 'hide-small' : selectedGroup, 'hide-all' : 0, 'collapsed' : showGroups, 'clickable' : selectedGroup || getOptions.group}"
           @click="getOptions.group ? showGroups = !showGroups : false">
        <span class="selected-color" :class="{'empty' : !getGroupImage}">
          <transition name="fade">
            <img v-if="getGroupImage" :src="getGroupImage"/>
          </transition>
        </span>
        <span class="tip" v-if="showGroups && !applyButton">Wybierz kolor z palety</span>
        <span class="tip" v-if="!showGroups && !applyButton">Wybierz inny kolor</span>

        <span class="collapsing" :class="{ 'collaps' : showGroups }" v-if="showGroups && getOptions.pa_tkanina">
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683418 12.0976 1.31658 11.7071 1.70711L6.70711 6.70711C6.31658 7.09763 5.68342 7.09763 5.29289 6.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893Z"
                  fill="#3C3C3C"/>
          </svg>
        </span>

      </div>
    </div>
    <div class="collection" ref="collectionContainer">
      <transition
          :enter-active-class="!isMobile ? 'animate__animated animate__slideInDown' : 'animate__animated animate__fadeIn animate__faster'"
          :leave-active-class="!isMobile ? 'animate__animated animate__slideOutUp' : 'animate__animated animate__fadeOut animate__faster'"
          mode="out-in">
        <ul class="options" id="colorOptions" v-show="showGroups" data-simplebar data-simplebar-auto-hide="false">
          <li v-for="attribute in getAttributes" @click="selectedGroup = attribute[0].group.id, applyChanges()"
              class="option"
              :class="{ 'selected' : attribute[0].group.id === selectedGroup, 'selected-previously' : attribute[0].group.id === getOptions.group}">
            <img :src="attribute[0].group.image"/>
            {{ attribute[0].group.name }}
          </li>
        </ul>
      </transition>
      <transition
          :enter-active-class="!isMobile ? 'animate__animated animate__slideInDown' : 'animate__animated animate__fadeIn animate__faster'"
          :leave-active-class="!isMobile ? 'animate__animated animate__slideOutUp' : 'animate__animated animate__fadeIn animate__faster'"
          mode="out-in">
        <ul class="options" id="fabricOptions" v-if="!!getOptions.group && !showGroups" data-simplebar
            data-simplebar-auto-hide="false">
          <li v-for="attribute in getAttributes[getOptions.group]"
              @click="setOption(attribute.id)"
              class="option rich flexible"
              :class="{ 'selected' : attribute.id === getOptions.pa_tkanina}">
            <image-item :source="attribute.image" class="image" :key="attribute.image" :custom="{ group: $options.filters.toRome(attribute.group.no), price: attribute.price_diff ? '+' + $options.filters.price(attribute.price_diff) : '' }"/>
            <div class="product-name">
              <div>{{ attribute.name }}
                <transition name="fade">
                  <span class="price-diff"
                        v-if="!getLoading && getOptions.pa_tkanina === attribute.id && getProductData.price_diff">(+{{
                      getProductData.price_diff | price
                    }})</span>
                </transition>
              </div>
              <p class="desc">{{ attribute.description }}</p>
              <p class="order" @click.stop="openProductCartPreview(attribute)">Zamów bezpłatną próbkę</p>
            </div>
            <button v-if="attribute.product" class="btn-info" @click.stop="openProductPreview(attribute)">
              <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.5 0C9.81371 0 12.5 2.68629 12.5 6C12.5 9.31371 9.81371 12 6.5 12C3.18629 12 0.5 9.31371 0.5 6C0.5 2.68629 3.18629 0 6.5 0ZM6.5 5C5.98716 5 5.56449 5.38604 5.50673 5.88338L5.5 6V9C5.5 9.55229 5.94772 10 6.5 10C7.01284 10 7.43551 9.61396 7.49327 9.11662L7.5 9V6C7.5 5.44772 7.05228 5 6.5 5ZM5.5 2L7.5 2V4L5.5 4V2Z"
                      fill="#3C3C3C"/>
              </svg>
            </button>
          </li>
          <li class="option rich no-clickable with-input" v-if="isProductWithCustom"
              :class="{ 'selected' : customFabric}">
            <div>
              <div>Chcesz inną tkaninę z próbnika?</div>
              <p class="desc">Wpisz jej nazwę poniżej i przejdź dalej</p>
              <input type="text" v-model="customFabric" v-debounce:400ms="customFabricInput"
                     placeholder="np. Spello 06, różowy"
                     ref="customFabric"
                     @focus="customFabricText = true"
                     @blur="customFabricText = false"/>
              <p class="text-as-link" @click="openFabricsPage">Zobacz wszystkie tkaniny</p>
              <p class="desc-info" v-if="customFabricText">Kwota zamówienia może ulec zmianie. Skontaktuj się z nami by
                potwierdzić cenę - +48 787 091 180</p>
            </div>
          </li>
        </ul>
      </transition>
    </div>

    <transition name="slide">
      <ProductPreview v-if="productPreview" :attribute="productToPreview" @close="closeProductPreview"/>
    </transition>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ProductPreview from "../ProductPreview";
import imageItem from '../misc/ImageItem';
import confirmDialog from "../../../mixins/confirm-dialog"
import {getDirective} from 'vue-debounce'

export default {
  name: "ColorFabric",
  components: {ProductPreview, imageItem},
  directives: {
    debounce: getDirective()
  },
  props: {
    attributes: {
      type: Array
    }
  },
  mixins: [confirmDialog],
  filters: {
    price(price) {
      return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(price)
    },
    toRome(number) {
      if (isNaN(number))
        return NaN;
      var digits = String(+number).split(""),
          key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
            "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
            "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
          roman = "",
          i = 3;
      while (i--)
        roman = (key[+digits.pop() + (i * 10)] || "") + roman;
      return Array(+digits.join("") + 1).join("M") + roman;
    }
  },
  data() {
    return {
      selectedGroup: null,
      selectedGroupTemp: null,
      selectedFabric: null,
      selectedFabricTemp: null,
      applyButton: false,
      showGroups: false,
      showColors: false,
      productPreview: false,
      productToPreview: null,
      windowWidth: window.innerWidth,
      customFabric: null,
      customFabricText: false
    }
  },
  watch: {
    'getOptions.custom_fabric'(n, o) {
      this.customFabric = n
    },
    'getOptions.group'(n, o) {
      // if (!o) {
      //   this.showGroups = true
      // }

      if (n && !o) {
        this.showGroups = false
      }

      if (o && n !== o) {
        this.selectedFabric = null
        // this.setOptionFabric(null)
      }
    },
    getStep() {
      this.productPreview = null
    },
    getConfirmationDialogConfirm(n) {
      if (!n) {
        return
      }

      this.setOptionFabric(this.selectedFabricTemp)
      this.fetchVariation(this.getOptions).then(() => {
        if (this.isMobile) {
          document.getElementById('customizer').scrollTo({top: 0, behavior: 'smooth'});
        }
        this.setConfirmationDialogConfirm(false)
      })
      this.closeConfirmDialog()
    }
  },
  computed: {
    ...mapGetters({
      getStep: 'customizer/getStep',
      getOptions: 'customizer/getOptions',
      getProductData: 'customizer/getProductData',
      getLoading: 'customizer/getLoading'
    }),
    isMobile() {
      return this.windowWidth <= 680
    },
    isProductWithCustom() {
      return !!this.attributes.find(item => item.group.id !== 'tkanina-z-probnika')
    },
    getAttributes() {
      let options = this.attributes
      options = options.filter(item => item.group.id !== 'tkanina-z-probnika' && item.id !== 'tkanina-z-probnika')
      options = options.reduce(function (r, a) {
        r[a.group.id] = r[a.group.id] || [];
        r[a.group.id].push(a);
        return r;
      }, Object.create(null));

      return options
    },
    getSteps() {
      return this.$parent.getSteps
    },
    getGroupImage() {
      if (this.selectedGroup) {
        return this.getAttributes[this.selectedGroup][0].group.image || null
      }
      if (this.getOptions.group) {
        return this.getAttributes[this.getOptions.group][0].group.image || null
      }
    },
    getContainerHeight() {
      return this.$refs.collectionContainer.clientHeight
    }
  },
  mounted() {
    if (this.getStep) {
      this.setStep({
        ...this.getSteps.find(step => step.id === this.getStep.id),
        completed: !!this.getOptions.pa_tkanina
      })
    }

    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })

    if (!this.getOptions.group) {
      this.showGroups = true
    }
    if (!this.getOptions.group && this.isMobile) {
      this.showGroups = true
    }
    this.selectedFabric = this.getOptions.pa_tkanina
    this.customFabric = this.getOptions.custom_fabric
  },
  updated() {
    if (!this.getOptions.group) {
      this.showGroups = true
    }

    if (!this.getOptions.group && this.isMobile) {
      this.showGroups = true
    }

    // if (this.getOptions.pa_tkanina) {
    //   this.setStep({
    //     ...this.getSteps.find(step => step.id === this.getStep.id),
    //     completed: !!this.getOptions.pa_tkanina
    //   })
    // }
  },
  methods: {
    ...mapMutations({
      setStep: 'customizer/setStep',
      setOptionGroup: 'customizer/setOptionGroup',
      setOptionFabric: 'customizer/setOptionFabric',
      setFabricCustom: 'customizer/setFabricCustom'
    }),
    ...mapActions({
      fetchVariation: 'customizer/fetchVariation'
    }),
    customFabricInput(e) {
      // if (this.getOptions.custom_fabric) {
      //   return
      // }
      this.setFabricCustom(e)
      this.fetchVariation(this.getOptions).then(() => {
        if (this.isMobile) {
          document.getElementById('customizer').scrollTo({top: 0, behavior: 'smooth'});
        }
      })
    },
    changeWCVariation() {
      const options = JSON.parse(JSON.stringify(this.getOptions))

      delete options.pa_additionals
      delete options.group

      let form = new FormData()

      Object.keys(options).forEach((item) => {
        if (options[item]) {
          form.append('attribute_' + item, options[item])

          const select = document.querySelector(`select#${item}`)
          if (select) {
            select.value = options[item]
            select.dispatchEvent(new Event("change", {"bubbles": true}))
          }
        }
      })
    },
    setOption(option) {
      this.selectedFabricTemp = null
      if (this.compareValuesFabric(option, this.getOptions.pa_tkanina)) {
        this.selectedFabricTemp = option
        this.openConfirmDialog()
        return
      }
      this.setFabricCustom(null)
      this.setOptionFabric(option)
      this.fetchVariation(this.getOptions).then(() => {
        if (this.isMobile) {
          document.getElementById('customizer').scrollTo({top: 0, behavior: 'smooth'});
        }
      })
    },
    showApplyChangesButton() {
      this.applyButton = true
    },
    applyChanges() {
      if (this.compareValuesFabric(this.selectedGroup, this.getOptions.group)) {
        this.selectedGroupTemp = this.getOptions.group || this.selectedGroup
        this.selectedFabricTemp = this.getOptions.pa_tkanina || this.selectedFabric
        this.setConfirmationDialogData({
          group: this.selectedGroupTemp || this.getOptions.group,
          fabric: this.selectedFabricTemp || this.getOptions.pa_tkanina
        })
      }

      if (this.selectedGroup) {
        this.setOptionGroup(this.selectedGroup)
        this.selectedGroup = null
        this.showGroups = false
      }

      if (this.selectedFabric) {
        this.setOptionFabric(this.selectedFabric)
        // this.selectedFabric = null
        // this.selectedGroup = null
      }

      this.applyButton = false
    },
    openProductCartPreview(product) {
      this.productPreview = true
      this.productToPreview = {...product, addToCart: true}
    },
    openProductPreview(product) {
      this.productPreview = true
      this.productToPreview = product
    },
    closeProductPreview() {
      this.productPreview = false
      this.productToPreview = null
      this.addToCartProduct = null
    },
    openFabricsPage() {
      window.open(process.env.VUE_APP_API + '/kategoria/probki-tkanin/', '_blank').focus();
    }
  }
}
</script>

<style scoped lang="scss">
.color-fabric {
  overflow: hidden;
  position: relative;
  height: 100%;

  display: flex;
  flex-flow: column;

  @media (max-width: 680px) {
    overflow: visible;
  }

  .toolbar {
    background: #fff;
    position: relative;
    z-index: 1;

    @media (max-width: 680px) {
      position: sticky;
      top: 0;
    }

    .btn-apply {
      padding: 12px 40px;
      display: inline-flex;
      align-items: center;
      background: #74C7ED;
      color: #fff;
      border: 0;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      transition: all .2s;
      cursor: pointer;
      position: absolute;
      top: 50%;
      right: 15%;
      transform: translateY(-50%);
      z-index: 1;

      @media (max-width: 768px) {
        padding: 12px 20px;
      }

      svg {
        width: 18px;
        height: auto;
        transition: all .2s;
        margin-right: 10px;

        path {
          fill: #fff;
        }
      }
    }

    .tip {
      padding: 5px 0;
      z-index: 1;
      background: #fff;
      color: #969696;
      //margin-left: auto;
      font-weight: 600;
    }

    .selected-color {
      display: inline-flex;
      width: 52px;
      height: 52px;
      margin-right: 15px;
      border: 1px solid #fff;

      &.empty {
        border: 1px solid #eee;
        border-radius: 100%;
      }

      @media (max-width: 768px) {
        width: 42px;
        height: 42px;
      }
    }

    .swatches {
      display: flex;
      align-items: center;
      padding: 25px 15% 25px 10%;
      border-bottom: 1px solid #efefef;

      &.clickable {
        cursor: pointer;
      }

      ul {
        margin: 0 auto;
        list-style: none;
        padding: 0;
        display: flex;
        align-items: center;
        cursor: pointer;

        //&.hide-small {
        //  //li:not(:first-child) {
        //  //  opacity: 0;
        //  //}
        //}
        //
        //&.hide-all {
        //  li {
        //    opacity: 0;
        //  }
        //}
        //
        //&.collapsed {
        //  li.normal {
        //    opacity: 0;
        //    &.selected {
        //      opacity: 1;
        //      margin-top: 7px;
        //    }
        //  }
        //}

        li {
          width: 23px;
          height: 23px;
          margin: 0 10px 0 0;
          //transition: all .2s;
          display: none;

          &:nth-child(-n+5) {
            display: inline-block;
          }

          &:last-child {
            padding: 0;
          }

          img {
            max-width: 100%;
            height: auto;
          }

          &.selected {
            transform: scale(1.75);
            order: -1;
            margin-right: 20px;
            margin-top: 7px;
          }
        }
      }

      .collapsing {
        margin-left: auto;
        transition: all .2s;
        transform-origin: 6px center;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        height: 25px;

        &.collaps {
          transform: rotate(180deg);
        }
      }
    }

  }

  .collection {
    overflow: hidden;
    position: relative;
    height: 650px;
    flex: 1;
    margin: 0 0 20px 0;

    .options {
      padding: 15px;
      margin: 0;
      overflow-y: auto;
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      background: #fff;

      @media (max-width: 480px) {
        position: relative;
        padding: 15px 0;
      }

      height: 100%;

      .option {
        display: flex;
        align-items: center;
        padding: 15px;
        border: 1px solid #efefef;
        border-radius: 5px;
        margin-bottom: 10px;
        cursor: pointer;
        font-weight: 600;
        font-size: 16px;
        color: #3C3C3C;
        transition: all .2s;
        &.flexible {
          justify-content: space-between;
        }

        @media (max-width: 480px) {
          font-size: 14px;
        }

        .image-placeholder {
          width: 70px;
          height: 70px;
          border-radius: 100%;
          display: inline-block;
          background: #eee;
          z-index: 1;
          margin-right: 15px;
        }

        label {
          display: flex;
          align-items: center;
        }

        input {
          display: none;
        }

        &.flexible {
          .product-name {
            margin-right: auto;
            padding-right: 15px;
          }
        }

        p.desc {
          font-size: 12px;
          font-weight: normal;
          color: #969696;
          margin: 0;
          line-height: 16px;
        }

        p.order {
          font-weight: 600;
          font-size: 12px;
          color: #3C91B8;
          margin: 0;
          line-height: 16px;
          cursor: pointer;
        }

        .price-diff {
          font-size: 12px;
          color: #969696;
        }

        .btn-info {
          flex: 0 0 32px;
          width: 32px;
          height: 32px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #efefef;
          border-radius: 4px;
          transition: all .2s;
          cursor: pointer;
          background: #fff;
          padding: 0;

          &:hover {
            background: #f5f5f5;
          }

          svg {
            width: 13px;
            height: 12px;
            display: inline-block;
          }
        }

        img, .image {
          margin-right: 15px;
        }

        img, .image::v-deep img {
          width: 23px;
          height: 23px;
        }

        &.selected {
          border: 1px solid #3c3c3c;
        }

        &.selected-previously {
          border: 1px solid #C8C8C8;
        }

        &.rich {
          .image {
            flex: 0 0 70px;
          }
          img, .image::v-deep img {
            width: 70px;
            height: 70px;
            border-radius: 70px;
          }
        }

        &.with-input {
          & > div {
            width: 100%;
          }

          input {
            display: block;
            width: 100%;
            border: 1px solid #EFEFEF;
            border-radius: 4px;
            color: #969696;
            font-size: 14px;
            padding: 10px 12px !important;
            margin: 8px 0;
            box-sizing: border-box;
            line-height: normal !important /*line-height: 2.3;*/
          ;
          }

          .desc {
            font-size: 14px;
            line-height: 20px;
            color: #3C3C3C;
          }

          .desc-info {
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.4px;
            color: #D3A221;
            margin: 5px 0 0 0;
          }
        }

        cursor: default;

        &:not(.no-clickable):hover {
          border: 1px solid #3c3c3c;
          cursor: pointer;
        }
      }
    }
  }
  .text-as-link {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #3C91B8;
    text-decoration: none;
    cursor: pointer;
    margin: 0;
  }
}

.list-enter,
.list-leave-to {
  visibility: hidden;
  height: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}

//.fade-enter-active, .fade-leave-active {
//  transition: opacity .2s;
//}
//
//.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//  opacity: 0;
//  position: absolute;
//}

.slide-leave-active,
.slide-enter-active,
.slide-leave-to {
  transition: transform .5s;
}

.slide-enter {
  transform: translate(100%, 0);
  position: absolute;
  @media (max-width: 480px) {
    position: fixed;
  }
}

.slide-leave-to {
  transform: translate(100%, 0);
  position: absolute;
  @media (max-width: 480px) {
    position: fixed;
  }
}

</style>
